/**
 * Do not edit directly — generated by `pnpm build-tokens`.
 */

export const tokens = {
  "colors": {
    "primary": {
      "100": "#fafeec",
      "200": "#f4fdcf",
      "300": "#e8fba0",
      "400": "#ddf970",
      "500": "#d2f740",
      "550": "#bdeb0a",
      "600": "#b3d049",
      "700": "#697c20",
      "800": "#343e10",
      "900": "#151906"
    },
    "neutral": {
      "100": "#fafafa",
      "200": "#f3f5f7",
      "300": "#edf0f3",
      "400": "#e6e6e6",
      "500": "#d9d9d9",
      "600": "#808080",
      "650": "#767676",
      "700": "#4d4d4d",
      "750": "#333333",
      "800": "#222423",
      "900": "#151514",
      "black": "#0c0c0b",
      "white": "#ffffff",
      "900-alpha-40": "rgba(21, 21, 20, 0.4)"
    },
    "success": {
      "100": "#edf3e5",
      "200": "#d1e1bf",
      "300": "#a3c380",
      "400": "#76a540",
      "500": "#488700",
      "600": "#396b00",
      "700": "#244400",
      "800": "#122200",
      "900": "#1d1509"
    },
    "info": {
      "100": "#ebeefb",
      "200": "#cdd4f5",
      "300": "#9aa7eb",
      "400": "#687ce2",
      "500": "#3651d8",
      "600": "#2c42af",
      "700": "#1b296c",
      "800": "#0e1536",
      "900": "#050816"
    },
    "error": {
      "100": "#fdeeef",
      "200": "#fcdddf",
      "300": "#f7a9af",
      "400": "#f37e88",
      "500": "#ef5360",
      "600": "#bf4550",
      "700": "#782a30",
      "800": "#3c1518",
      "900": "#18080a"
    },
    "warning": {
      "100": "#fdf4e7",
      "200": "#f9e4c2",
      "300": "#f3c985",
      "400": "#eeae49",
      "500": "#e8930c",
      "600": "#b37109",
      "700": "#744a06",
      "800": "#3a2503",
      "900": "#2d160a"
    },
    "lime": {
      "100": "#fafeec",
      "200": "#f4fdcf",
      "300": "#e8fba0",
      "400": "#ddf970",
      "500": "#d2f740",
      "550": "#bdeb0a",
      "600": "#b3d049",
      "700": "#697c20",
      "800": "#343e10",
      "900": "#151906"
    },
    "gray": {
      "100": "#fafafa",
      "200": "#f3f5f7",
      "300": "#edf0f3",
      "400": "#e6e6e6",
      "500": "#d9d9d9",
      "600": "#808080",
      "650": "#767676",
      "700": "#4d4d4d",
      "750": "#333333",
      "800": "#222423",
      "900": "#151514",
      "900-alpha-40": "rgba(21, 21, 20, 0.4)"
    },
    "red": {
      "100": "#fdeeef",
      "200": "#fcdddf",
      "300": "#f7a9af",
      "400": "#f37e88",
      "500": "#ef5360",
      "600": "#bf4550",
      "700": "#782a30",
      "800": "#3c1518",
      "900": "#18080a"
    },
    "orange": {
      "100": "#fdf4e7",
      "200": "#f9e4c2",
      "300": "#f3c985",
      "400": "#eeae49",
      "500": "#e8930c",
      "600": "#b37109",
      "700": "#744a06",
      "800": "#3a2503",
      "900": "#2d160a"
    },
    "green": {
      "100": "#edf3e5",
      "200": "#d1e1bf",
      "300": "#a3c380",
      "400": "#76a540",
      "500": "#488700",
      "600": "#396b00",
      "700": "#244400",
      "800": "#122200",
      "900": "#1d1509"
    },
    "blue": {
      "100": "#ebeefb",
      "200": "#cdd4f5",
      "300": "#9aa7eb",
      "400": "#687ce2",
      "500": "#3651d8",
      "600": "#2c42af",
      "700": "#1b296c",
      "800": "#0e1536",
      "900": "#050816"
    },
    "white": "#ffffff",
    "black": "#0c0c0b",
    "cyan": {
      "100": "#e6fffb",
      "200": "#b2fff3",
      "300": "#87e8de",
      "400": "#13c2c2",
      "500": "#0f9595",
      "600": "#0b7070",
      "700": "#084b4b",
      "800": "#042525",
      "900": "#021616"
    },
    "purple": {
      "100": "#f9f0ff",
      "200": "#d3adf7",
      "300": "#b97df2",
      "400": "#8e58da",
      "500": "#722ed1",
      "600": "#56239d",
      "700": "#391769",
      "800": "#1b0b32",
      "900": "#11071f"
    },
    "blackAlpha65": "rgba(12, 12, 11, 0.65)",
    "blackAlpha80": "rgba(12, 12, 11, 0.8)",
    "blackAlpha85": "rgba(12, 12, 11, 0.85)"
  },
  "typography": {
    "fontWeight": {
      "light": 300,
      "bold": 700,
      "regular": 400
    },
    "fontFamily": {
      "primary": "ProximaNova",
      "secondary": "Roboto Mono"
    },
    "fontSize": {
      "body": {
        "sm": "12px",
        "md": "14px",
        "lg": "16px"
      },
      "heading": {
        "h4": "16px",
        "h3": "20px",
        "h2": "24px",
        "h1": "28px"
      },
      "labels": {
        "label-md": "14px",
        "label-sm": "12px",
        "overline": "12px"
      },
      "additional": {
        "caption-md": "12px",
        "code": "12px",
        "caption-sm": "10px"
      }
    },
    "lineHeight": {
      "body": {
        "sm": 1.5,
        "lg": 1.5,
        "md": 1.4286
      },
      "heading": {
        "h4": 1.375,
        "h3": 1.3,
        "h2": 1.25,
        "h1": 1.25
      },
      "labels": {
        "label-md": 1,
        "label-sm": 1.1667,
        "overline": 1.1667
      },
      "additional": {
        "caption-md": 1.1667,
        "code": 1.5,
        "caption-sm": 1.2
      }
    },
    "paragraphSpacing": {
      "body": {
        "lg": "20px",
        "md": "16px",
        "sm": "12px"
      },
      "heading": {
        "h1": "36px",
        "h2": "32px",
        "h3": "28px",
        "h4": "24px"
      },
      "labels": {
        "label-md": "16px",
        "label-sm": "12px",
        "overline": "8px"
      },
      "additional": {
        "caption-md": "8px",
        "code": "12px",
        "caption-sm": "8px"
      }
    }
  },
  "shadows": {
    "dropdown": "0px 0px 6px 0px rgba(12, 12, 11, 0.08)",
    "switch": "0px 0px 4px 0px rgba(12, 12, 11, 0.04)",
    "modal": "0px 2px 16px 0px rgba(12, 12, 11, 0.04)"
  },
  "spacing": {
    "scale": {
      "0": "0px",
      "25": "1px",
      "50": "2px",
      "100": "4px",
      "200": "6px",
      "300": "8px",
      "400": "12px",
      "500": "16px",
      "600": "20px",
      "700": "24px",
      "800": "32px",
      "900": "40px",
      "1000": "48px",
      "1100": "64px",
      "1200": "80px",
      "1300": "96px",
      "1400": "120px"
    },
    "spacing": {
      "xxxs": "4px",
      "xs": "8px",
      "md": "12px",
      "lg": "16px",
      "xl": "20px",
      "xxl": "24px",
      "xxs": "6px",
      "xxxxs": "2px"
    },
    "padding": {
      "xxxs": "4px",
      "xs": "8px",
      "md": "12px",
      "lg": "16px",
      "xl": "20px",
      "xxxl": "32px",
      "xxl": "24px",
      "xxs": "6px",
      "xxxxs": "2px"
    },
    "borderWidth": {
      "xs": "1px",
      "sm": "2px",
      "md": "4px",
      "lg": "8px"
    },
    "radius": {
      "50": "2px",
      "100": "4px",
      "200": "6px",
      "300": "8px",
      "400": "12px",
      "500": "16px",
      "600": "20px",
      "none": "0px",
      "round": "9999px"
    }
  },
  "zIndex": {
    "base": 0,
    "raised": 10,
    "sticky": 100,
    "dropdown": 1000,
    "overlay": 1100,
    "drawer": 1200,
    "modal": 1300,
    "popover": 1400,
    "toast": 1500,
    "tooltip": 1600
  },
  "breakpoints": {
    "xs": "0px",
    "sm": "600px",
    "md": "900px",
    "lg": "1200px",
    "xl": "1536px"
  },
  "layout": {
    "topBarHeight": "50px",
    "navbarWidth": "220px",
    "navbarCollapsedWidth": "50px",
    "breadcrumbBarHeight": "35px",
    "navbarTransitionDuration": "300ms"
  },
  "theme": {
    "light": {
      "text": {
        "heading": "#0c0c0b",
        "body": "#4d4d4d",
        "action": "#697c20",
        "actionHover": "#343e10",
        "disabled": "#808080",
        "information": "#3651d8",
        "success": "#488700",
        "warning": "#e8930c",
        "error": "#bf4550",
        "onAction": "#0c0c0b",
        "onDisabled": "#808080",
        "navigation": "#d9d9d9",
        "navigationActive": "#edf0f3",
        "avatar": "#4d4d4d",
        "secondary": "#767676",
        "headingOnDark": "#d9d9d9",
        "bodyOnDark": "#808080",
        "tint": {
          "red": "#be414c",
          "blue": "#2c42af",
          "green": "#396b00",
          "cyan": "#0b7070",
          "purple": "#56239d",
          "orange": "#9b6208",
          "lime": "#697c20",
          "gray": "#4d4d4d",
          "gray-hover": "#222423"
        },
        "placeholderActive": "#d9d9d9"
      },
      "surface": {
        "main": {
          "page": "#fafafa",
          "cards": "#ffffff",
          "container-on-card": "#fafafa",
          "element-on-container": "#edf0f3",
          "element-on-card": "#f3f5f7",
          "cards-2": "#ffffff",
          "modal-backdrop": "rgba(21, 21, 20, 0.4)"
        },
        "primary": {
          "action": "#d2f740",
          "action-border": "#bdeb0a",
          "action-hover": "#b3d049",
          "action-focused": "#d2f740",
          "background": "#fafeec"
        },
        "secondary": {
          "action": "#d9d9d9",
          "action-hover": "#f4fdcf",
          "action-focused": "#d2f740",
          "background": "#edf0f3"
        },
        "disabled": {
          "action": "#edf0f3",
          "action-hover": "#e6e6e6",
          "action-focused": "#edf0f3",
          "background": "#f3f5f7"
        },
        "error": {
          "action": "#ef5360",
          "action-hover": "#bf4550",
          "action-focused": "#ef5360",
          "background": "#fdeeef"
        },
        "information": {
          "action": "#3651d8",
          "action-hover": "#2c42af",
          "action-focused": "#3651d8",
          "background": "#ebeefb"
        },
        "success": {
          "action": "#488700",
          "action-hover": "#396b00",
          "action-focused": "#488700",
          "background": "#edf3e5"
        },
        "warning": {
          "action": "#e8930c",
          "action-hover": "#b37109",
          "action-focused": "#e8930c",
          "background": "#fdf4e7"
        },
        "navigation": {
          "navigation-item": "#222423",
          "navigation": "#151514"
        },
        "scrollbar": {
          "thumb": "#d9d9d9",
          "track": "#ffffff"
        },
        "tint": {
          "red": "#fdeeef",
          "blue": "#ebeefb",
          "green": "#edf3e5",
          "cyan": "#e6fffb",
          "purple": "#f9f0ff",
          "orange": "#fdf4e7",
          "lime": "#fafeec",
          "gray": "#fafafa"
        },
        "switch": {
          "handle": "#ffffff",
          "track-inactive": "#d9d9d9",
          "track-inactive-disabled": "#e6e6e6",
          "track-active-disabled": "#e8fba0",
          "track-active": "#d2f740"
        },
        "avatar": {
          "background-default": "#edf0f3",
          "icon": "#808080",
          "border": "#ffffff"
        }
      },
      "icon": {
        "primary": "#0c0c0b",
        "success": "#488700",
        "error": "#ef5360",
        "warning": "#e8930c",
        "information": "#3651d8",
        "action": "#b3d049",
        "secondary": "#808080",
        "disabled": "#808080",
        "navigation": "#d9d9d9",
        "primaryHover": "#4d4d4d",
        "primaryOnDark": "#d9d9d9",
        "tint": {
          "gray": "#4d4d4d",
          "gray-hover": "#222423"
        }
      },
      "border": {
        "primary": "#e6e6e6",
        "secondary": "#bdeb0a",
        "success": "#488700",
        "info": "#3651d8",
        "warning": "#e8930c",
        "error": "#ef5360",
        "action": "#bdeb0a",
        "actionHover": "#b3d049",
        "disabled": "#d9d9d9",
        "focus": "#bdeb0a",
        "secondaryHover": "#b3d049",
        "tags": "#d9d9d9",
        "inputFieldDisabled": "#e6e6e6",
        "inputFieldDefault2": "#808080",
        "tint": {
          "purple": "#d3adf7",
          "lime": "#d2f740",
          "gray": "#e6e6e6",
          "gray-hover": "#d9d9d9",
          "red": "#f7a9af",
          "blue": "#9aa7eb",
          "green": "#a3c380",
          "cyan": "#87e8de",
          "orange": "#f3c985"
        },
        "focusPrimary": "#bdeb0a"
      }
    },
    "dark": {
      "text": {
        "heading": "#ffffff",
        "body": "#edf0f3",
        "action": "#697c20",
        "actionHover": "#343e10",
        "disabled": "#808080",
        "information": "#687ce2",
        "success": "#76a540",
        "warning": "#eeae49",
        "error": "#f37e88",
        "onAction": "#0c0c0b",
        "onDisabled": "#4d4d4d",
        "navigation": "#d9d9d9",
        "navigationActive": "#edf0f3",
        "avatar": "#d9d9d9",
        "secondary": "#808080",
        "headingOnDark": "#d9d9d9",
        "bodyOnDark": "#808080",
        "tint": {
          "red": "#f37e88",
          "blue": "#687ce2",
          "green": "#76a540",
          "cyan": "#13c2c2",
          "purple": "#b97df2",
          "orange": "#eeae49",
          "lime": "#ddf970",
          "gray": "#edf0f3",
          "gray-hover": "#fafafa"
        },
        "placeholderActive": "#4d4d4d"
      },
      "surface": {
        "main": {
          "page": "#222423",
          "cards": "#151514",
          "container-on-card": "#222423",
          "element-on-container": "#4d4d4d",
          "element-on-card": "#222423",
          "cards-2": "#151514",
          "modal-backdrop": "rgba(21, 21, 20, 0.4)"
        },
        "primary": {
          "action": "#d2f740",
          "action-border": "#bdeb0a",
          "action-hover": "#b3d049",
          "action-focused": "#d2f740",
          "background": "#151906"
        },
        "secondary": {
          "action": "#4d4d4d",
          "action-hover": "#343e10",
          "action-focused": "#d2f740",
          "background": "#333333"
        },
        "disabled": {
          "action": "#4d4d4d",
          "action-hover": "#4d4d4d",
          "action-focused": "#4d4d4d",
          "background": "#222423"
        },
        "error": {
          "action": "#ef5360",
          "action-hover": "#bf4550",
          "action-focused": "#ef5360",
          "background": "#18080a"
        },
        "information": {
          "action": "#3651d8",
          "action-hover": "#2c42af",
          "action-focused": "#3651d8",
          "background": "#050816"
        },
        "success": {
          "action": "#488700",
          "action-hover": "#396b00",
          "action-focused": "#488700",
          "background": "#1d1509"
        },
        "warning": {
          "action": "#e8930c",
          "action-hover": "#b37109",
          "action-focused": "#e8930c",
          "background": "#2d160a"
        },
        "navigation": {
          "navigation-item": "#222423",
          "navigation": "#151514"
        },
        "scrollbar": {
          "thumb": "#151514",
          "track": "#4d4d4d"
        },
        "tint": {
          "red": "#18080a",
          "blue": "#050816",
          "green": "#1d1509",
          "cyan": "#021616",
          "purple": "#11071f",
          "orange": "#2d160a",
          "lime": "#151906",
          "gray": "#222423"
        },
        "switch": {
          "handle": "#151514",
          "track-inactive": "#4d4d4d",
          "track-inactive-disabled": "#4d4d4d",
          "track-active-disabled": "#697c20",
          "track-active": "#d2f740"
        },
        "avatar": {
          "background-default": "#222423",
          "icon": "#808080",
          "border": "#151514"
        }
      },
      "icon": {
        "primary": "#ffffff",
        "success": "#76a540",
        "error": "#f37e88",
        "warning": "#eeae49",
        "information": "#687ce2",
        "action": "#ddf970",
        "secondary": "#808080",
        "disabled": "#4d4d4d",
        "navigation": "#d9d9d9",
        "primaryHover": "#edf0f3",
        "primaryOnDark": "#d9d9d9",
        "tint": {
          "gray": "#edf0f3",
          "gray-hover": "#fafafa"
        }
      },
      "border": {
        "primary": "#4d4d4d",
        "secondary": "#d2f740",
        "success": "#76a540",
        "info": "#687ce2",
        "warning": "#eeae49",
        "error": "#f37e88",
        "action": "#ddf970",
        "actionHover": "#b3d049",
        "disabled": "#4d4d4d",
        "focus": "#ddf970",
        "secondaryHover": "#ddf970",
        "tags": "#4d4d4d",
        "inputFieldDisabled": "#4d4d4d",
        "inputFieldDefault2": "#808080",
        "tint": {
          "purple": "#8e58da",
          "lime": "#ddf970",
          "gray": "#4d4d4d",
          "gray-hover": "#4d4d4d",
          "red": "#f7a9af",
          "blue": "#9aa7eb",
          "green": "#a3c380",
          "cyan": "#87e8de",
          "orange": "#f3c985"
        },
        "focusPrimary": "#ddf970"
      }
    }
  },
  "components": {
    "switch": {
      "active-enabled-background": "#d2f740",
      "active-disabled-background": "#e8fba0",
      "inactive-enabled-background": "#d9d9d9",
      "inactive-disabled-background": "#e6e6e6",
      "handle": "#ffffff"
    },
    "tag": {
      "color": {
        "red": {
          "background": "#fdeeef",
          "border": "#f7a9af",
          "text": "#be414c"
        },
        "blue": {
          "background": "#ebeefb",
          "border": "#9aa7eb",
          "text": "#2c42af"
        },
        "green": {
          "background": "#edf3e5",
          "border": "#a3c380",
          "text": "#396b00"
        },
        "cyan": {
          "background": "#e6fffb",
          "border": "#87e8de",
          "text": "#0b7070"
        },
        "purple": {
          "background": "#f9f0ff",
          "border": "#d3adf7",
          "text": "#56239d"
        },
        "orange": {
          "background": "#fdf4e7",
          "border": "#f3c985",
          "text": "#9b6208"
        },
        "lime": {
          "background": "#fafeec",
          "border": "#d2f740",
          "text": "#697c20"
        },
        "gray": {
          "background": "#fafafa",
          "background-hover": "#fafafa",
          "border": "#e6e6e6",
          "text": "#4d4d4d",
          "text-hover": "#222423",
          "icon-hover": "#222423",
          "icon": "#4d4d4d"
        }
      }
    },
    "table": {
      "surface": "#fafafa",
      "header-background": "#ffffff",
      "header-text": "#0c0c0b",
      "header-border": "#e6e6e6",
      "header-divider": "#e6e6e6",
      "row-background": "#ffffff",
      "row-background-hover": "#fafafa",
      "row-background-selected": "#fafeec",
      "row-background-disabled": "#f3f5f7",
      "row-border": "#e6e6e6",
      "row-accent": "#d2f740",
      "cell-text": "#4d4d4d",
      "cell-text-strong": "#0c0c0b",
      "cell-text-muted": "#767676",
      "cell-text-disabled": "#808080",
      "control-icon": "#808080",
      "control-icon-active": "#b3d049"
    },
    "field": {
      "background": "#ffffff",
      "background-disabled": "#ffffff",
      "border": "#808080",
      "border-hover": "#bdeb0a",
      "border-active": "#bdeb0a",
      "border-disabled": "#e6e6e6",
      "border-error": "#ef5360",
      "focus-ring": "#bdeb0a",
      "text": "#0c0c0b",
      "text-placeholder": "#767676",
      "text-disabled": "#808080",
      "text-error": "#bf4550",
      "label": "#0c0c0b",
      "icon": "#808080",
      "icon-disabled": "#808080",
      "text-placeholder-hover": "#4d4d4d",
      "text-placeholder-active": "#d9d9d9"
    },
    "navigation": {
      "main": {
        "surface": "#151514",
        "title": "#d9d9d9",
        "section-label": "#808080",
        "item-background-hover": "#222423",
        "item-background-active": "#222423",
        "item-border-active": "#d2f740",
        "item-text": "#d9d9d9",
        "item-text-active": "#edf0f3",
        "item-icon": "#d9d9d9",
        "badge-background": "#d2f740",
        "badge-text": "#0c0c0b"
      },
      "secondary": {
        "surface": "#fafafa",
        "border": "#e6e6e6",
        "section-label": "#767676",
        "item-background-hover": "#edf0f3",
        "item-background-active": "#edf0f3",
        "item-border-active": "#d2f740",
        "item-text": "#4d4d4d",
        "item-text-active": "#0c0c0b",
        "item-icon": "#808080",
        "item-icon-active": "#0c0c0b"
      }
    }
  }
} as const;

export default tokens;
